<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.订阅项目名称') }}<template slot="title">{{ $t('会员订阅档位.订阅项目名称') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.name"
          :maxLength="64"
          :placeholder="$t('通用.输入.请输入')+$t('会员订阅档位.订阅项目名称')"/>
      </a-form-model-item>
      <a-form-model-item prop="originalPrice">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.订阅项目原价') }}<template slot="title">{{ $t('会员订阅档位.订阅项目原价') }}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.originalPrice" :min="0" :max="999999" :step="0.01" style="width: 100%"  :placeholder="$t('通用.输入.请输入')+$t('会员订阅档位.订阅项目原价')"/>
      </a-form-model-item>
      <a-form-model-item prop="price">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.订阅项目现价') }}<template slot="title">{{ $t('会员订阅档位.订阅项目现价') }}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.price" :min="0" :max="999999" :step="0.01" style="width: 100%"  :placeholder="$t('通用.输入.请输入')+$t('会员订阅档位.订阅项目现价')"/>
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.排序') }}<template slot="title">{{ $t('会员订阅档位.排序') }}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.sort" :min="0" :max="999999" style="width: 100%" :placeholder="$t('通用.输入.请输入')+$t('会员订阅档位.排序')"/>
      </a-form-model-item>
      <a-form-model-item prop="validityPeriod">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.有效期(天)') }}<template slot="title">{{ $t('会员订阅档位.有效期(天)') }}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.validityPeriod" :min="0" :max="99999" style="width: 100%;"  :placeholder="$t('通用.输入.请输入')+$t('会员订阅档位.有效期(天)')"/>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>
            {{ $t('会员订阅档位.备注') }}<template slot="title">{{ $t('会员订阅档位.备注') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSubscribeLevel, addSubscribeLevel, updateSubscribeLevel } from '@/api/user/subscribeLevel'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        levelType: 30,
        levelId: 2,
        name: null,
        originalPrice: null,
        price: null,
        sort: null,
        validityPeriod: 30,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        levelId: [
          {
            required: true,
            message: this.$t('会员订阅档位.会员等级名称') + this.$t('通用.文本.不能为空'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('会员订阅档位.订阅项目名称') + this.$t('通用.文本.不能为空'),
            trigger: 'blur'
          }
        ],
        originalPrice: [
          {
            required: true,
            message: this.$t('会员订阅档位.订阅项目原价') + this.$t('通用.文本.不能为空'),
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            message: this.$t('会员订阅档位.订阅项目现价') + this.$t('通用.文本.不能为空'),
            trigger: 'blur'
          }
        ],
        sort: [
          { required: true, message: this.$t('会员订阅档位.排序') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        validityPeriod: [
          { required: true, message: this.$t('会员订阅档位.有效期(天)') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        levelType: 30,
        levelId: 2,
        name: null,
        originalPrice: null,
        price: null,
        sort: null,
        validityPeriod: 30,
        createTime: null,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSubscribeLevel({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    changeType(e) {
      this.form.validityPeriod = e.target.value
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateSubscribeLevel(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(
                  message,
                  3
                );
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addSubscribeLevel(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(
                  message,
                  3
                )
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
